
<div class="confirmed-message">
    <svg-icon
        icon="check"
        class="icon--success"
    /><span class="confirmed-message__text"><slot /></span>
</div>
